exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pinch-scroll-zoom > .pinch-scroll-zoom__content {\n  top: 10% !important;\n  left: 10% !important;\n}\n.button-dialog {\n}\n", ""]);

// exports
